import { render, staticRenderFns } from "./data-record-table-widget.vue?vue&type=template&id=3d95fb94&scoped=true"
import script from "./data-record-table-widget.vue?vue&type=script&lang=js"
export * from "./data-record-table-widget.vue?vue&type=script&lang=js"
import style0 from "./data-record-table-widget.vue?vue&type=style&index=0&id=3d95fb94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d95fb94",
  null
  
)

export default component.exports